<div class="order-creation-wrapper" *transloco="let t">
    @if(store()?.hasStoreChooser && !isInCheckout() && !embedded()){
        <div class="store-details-container">
            <div class="upper-container">
                <div class="left-wrapper">
                    <cwo-icon [name]="iconName.store" class="icon"/>
                    <span>{{t('shared_components.order_creation_form.you_r_ordering_from')}}</span>
                </div>
                <button class="button-undecorated change-store-button" (click)="handleChangeStore()">{{t('shared_components.order_creation_form.change_store')}}</button>
            </div>
            @if(store()){
                <cwo-dotted-labels 
                    [labels]="[store()!.name, store()!.address ?? '']"
                    [state]="'inactive'"
                    [fontSize]="'var(--font-size-med)'"
                    [fontWeight]="'var(--font-weight-medium)'"
                    [color]="'var(--primary-text-color)'"
                />
            }
            @if(shouldShowMakeFavoriteStore  && !embedded()) {
                <button class="make-this-my-location button-undecorated" (click)="setFavoriteStore()">
                    @if(displaySuccessCheck) {
                        <cwo-icon [name]="iconName.check" class="icon"/>
                    }
                    <span>{{t('shared_components.order_creation_form.make_this_my_location')}}</span>
                </button>
            }
        </div>
    }
    <div class="primary-container" 
        [style.padding-left]="isInCheckout() ? '0' : ''"
        [style.padding-right]="isInCheckout() ? '0' : ''"
    >
        @if(parsedErrors){
            <cwo-parse-errors-message [parsedErrors]="parsedErrors"/>
        }

        <div class="order-type-container">
            <span class="title" tabindex="0">{{t('shared_components.order_creation_form.order_type')}}</span>
            <span class="order_type_message" tabindex="0">{{t('shared_components.order_creation_form.order_type_message')}}</span>
            <span class="description">{{activeOrderType()?.description}}</span>
            <cwo-order-details-button-group [optionValues]="this.configService.configState().orderTypeValues" [ariaLabelValues]="orderTypeAriaLabels()"
                [radioGroupName]="'Order Type'" style="width: 100%;" (valueChange)="onOrderTypeChange($event)" [selectedValue]="activeOrderType()?.type">
                @for (type of this.configService.configState().orderTypes; track type.type) {
                <span *cwoTemplateMarker class="option-button" [ngClass]="{'active': activeOrderType()?.type === type.type}">
                    <cwo-icon [name]="getIconName(type.type)" class="icon" />
                    <div class="text-container">
                        <span class="label">{{type.displayName ?? type.type}}</span>
                        @if(!orderTypeConfigsLoading && schedule() === 'ASAP' && activeOrderType()?.type === type.type && orderTimeInfo() && orderTimeInfo()?.promiseTime && orderTimeInfo()?.promiseTimeLeeway){
                            <span class="secondary-text">{{t('shared_components.order_creation_form.promise_time',{start: orderTimeInfo()?.promiseTime, end: orderTimeInfo()?.promiseTime! + orderTimeInfo()?.promiseTimeLeeway!})}}</span>
                        }
                    </div>
                </span>
                }
            </cwo-order-details-button-group>
            @if(showOrderTypeError){
                <span class="input-error order-type-error">
                    <cwo-icon class="icon" [name]="iconName.error"></cwo-icon>
                    {{t('shared_components.order_creation_form.select_order_type')}}
                </span>
            }
        </div>
        @if (storeStatusAny()?.isOpen === false && !orderTypeConfigsLoading) {
            <div class="error-container" *transloco="let t">
                <cwo-icon [name]="iconName.error" [size]="'1rem'" class="error-icon" />
                <div class="error-message">
                    {{t('shared_components.order_creation_form.store_is_closed')}}
                </div>
            </div>
        } 
        @else if ((deferChoices.length === 1 && deferChoices[0] === 'Future') && !orderTypeConfigsLoading && order().noticePeriod === 0) {
            <div class="error-container" *transloco="let t">
            <cwo-icon [name]="iconName.error" [size]="'1rem'" class="error-icon" />
            <div class="error-message">
                {{t('shared_components.order_creation_form.order_type_is_closed', {order_type: activeOrderType()?.displayName ?? activeOrderType()?.type})}}
            </div>
        </div>
        }
        @if(orderTypeConfigsLoading){
            <div style="width: 100%; display: flex; justify-content: center;">
                <div class="base-spinner"></div>
            </div>
        }
        @if(activeOrderType()?.type && !orderTypeConfigsLoading) {
            <div class="schedule-container">
                <div class="schedule-header" >
                    <span class="title" tabindex="-1" #scheduleHeaderTitle>{{t('shared_components.order_creation_form.schedule')}}</span>
                    <span class="schedule_message" tabindex="0">{{t('shared_components.order_creation_form.schedule_message')}}</span>
                </div>
                @if(timeSlotsDescriptionText){
                    <span class="timeslots-description">
                        {{t('shared_components.order_creation_form.timeslots_description', {orderType: activeOrderType()?.displayName ?? activeOrderType()?.type})}}
                        <span class="available-hours-label">
                            {{timeSlotsDescriptionText}}
                        </span>
                    </span>
                }
                @if(deferChoices.length !== 1 || (deferChoices.length && deferChoices[0] !== 'Future')){
                    <cwo-order-details-button-group [optionValues]="deferChoices" [ariaLabelValues]="deferChoiceAriaLabels()" [radioGroupName]="'Schedule'"
                        (valueChange)="onTimeChoiceChanged($event)" style="width: 100%;" [selectedValue]="schedule()">
                        @for (choice of deferChoices; track $index) {
                            <span *cwoTemplateMarker class="option-button" [ngClass]="{'active': schedule() === choice}">
                                <div class="text-container">
                                    <span class="label">{{getAsapLabel(choice)}}</span>
                                </div>
                            </span>
                        }
                    </cwo-order-details-button-group>
                }
            </div>

            @switch (schedule()) {
                @case ('Today') {
                    <cwo-time-select
                        [disabled]="!deferDate()"
                        [orderType]="activeOrderType()?.type ?? orderType.Any" 
                        [stared]="true" 
                        [inputDate]="deferDate()"
                        [timeSlots]="timeSlots()"
                        (defferDateChanged)="handleDefferDateUpdates($event)" 
                        (availableHours)="handleAvailableHours($event)"
                    />
                }
                @case ('Future') {
                   <cwo-iconed-selection-button 
                        [for]="'ORDERING_CALENDAR'"
                        [deferredDayTimes]="storeStatus()?.deferredDayTimes ?? storeStatusValue()?.deferredDayTimes"
                        [orderType]="activeOrderType()?.type ?? orderType.Any"
                        [stared]="true"
                        [inputDate]="deferDate()"
                        (defferDateChanged)="handleDefferDateUpdates($event)"
                        (availableHours)="handleAvailableHours($event)"
                        (storeClosedForSelectedDate)="handleStoreClosedForSelectedDate($event)"
                    />
                    <cwo-time-select
                        [disabled]="!deferDate()"
                        [orderType]="activeOrderType()?.type ?? orderType.Any" 
                        [stared]="true" 
                        [inputDate]="deferDate()"
                        [timeSlots]="timeSlots()"
                        (defferDateChanged)="handleDefferDateUpdates($event)"
                        (availableHours)="handleAvailableHours($event)"
                    />
                }
            }
        }


        

        @if (activeOrderType()?.type === orderType.Delivery && !storeStatusService.loadingTimeDefferOptions()) {
            @if(accountAddresses().length){
                <div class="saved-addresses-container">
                    <span class="section-title saved-addresses-title">{{t('shared_components.order_creation_form.saved_addresses')}}</span>
                    <div class="saved-addresses-wrapper">
                        @for (address of accountAddresses(); track $index) {
                            <div class="account-address-wrapper">
                                <cwo-account-address [address]="address" (action)="savedAddressAction($event, address)" [selected]="address.name === selectedAddress()?.name"/>
                                @if(address.name === selectedAddress()?.name && validationResponse?.error){
                                    <cwo-out-of-delivery-warning 
                                        [highlightOverrideMessage]="highlightOverrideMessage"
                                        [validationResponse]="validationResponse"
                                        (continueOverride)="handleOverrideAddress()"
                                        (noThankYou)="handleNoThankyou()"
                                        [orderType]="activeOrderType()"
                                        [redirectParams]="address"
                                    />
                                }
                            </div>
                        }
                    </div>
                </div>
                
                @if(!showNewAddressForm){
                    @if(address() && address()?.name && !selectedAddress()){
                        <div class="temp-address-wrapper">
                            <span class="section-title address-title">{{t('shared_components.order_creation_form.address')}}</span>
                            <cwo-temp-address [address]="address()" (editAddress)="editOrderAddress($event)" />
                        </div>
                    }
                    <button class="button-undecorated add-new-address" (click)="toggleNewAddressForm()">
                        {{t('shared_components.order_creation_form.add_new')}}
                    </button>
                    @if(address() && !address()?.name && address()?.street && !selectedAddress()) {
                        <cwo-address-form #addressFormComponent 
                            [validationResponse]="validationResponse" 
                            [address]="address()" 
                            (isFormValid)="handleAddressFormValidation($event)" 
                            (overrideAddress)="handleOverrideAddress()"
                            (noThankYou)="handleNoThankyou()"
                            (formChanging)="handleFormChanging()"
                            [allErrors]="serverErrors"
                            [orderType]="activeOrderType()"
                        />
                    }
                } @else {
                    <cwo-address-form #addressFormComponent 
                        [validationResponse]="validationResponse" 
                        [address]="undefined" 
                        (isFormValid)="handleAddressFormValidation($event)" 
                        (overrideAddress)="handleOverrideAddress()"
                        (noThankYou)="handleNoThankyou()"
                        (formChanging)="handleFormChanging()"
                        [allErrors]="serverErrors"
                        [orderType]="activeOrderType()"
                    />           
                }
            } @else {
                <cwo-address-form #addressFormComponent 
                    [validationResponse]="validationResponse" 
                    [address]="address()" 
                    (isFormValid)="handleAddressFormValidation($event)" 
                    (overrideAddress)="handleOverrideAddress()"
                    (noThankYou)="handleNoThankyou()"
                    (formChanging)="handleFormChanging()"
                    [allErrors]="serverErrors"
                    [orderType]="activeOrderType()"
                />
            }    
        }
    </div>
</div>
